module.exports = "/assets/data/32d09c75807c30d26811eb39aa5c668e-SS8.data.json";